import React from "react";
import { useForm } from "@mantine/hooks";
import {
  TextInput,
  PasswordInput,
  Text,
  Paper,
  Button,
  Group,
  Container,
  Alert,
} from "@mantine/core";

export function Signup(props) {
  const form = useForm({
    initialValues: {
      email: "",
      name: "",
      password: "",
    },

    validationRules: {
      email: (val) => /^\S+@\S+$/.test(val),
      password: (val) => val.length >= 6,
    },
  });

  const handleSubmit = (values) => {
    // Signup functionality not implemented yet
    console.log("Signup form submitted:", values);
  };

  return (
    <Container size={400} px={0}>
      <Paper radius="md" p="xl" withBorder {...props}>
        <Text size="lg" weight={500} mb="md">
          Welcome to Bugsjoy🪲
        </Text>

        <Alert color="blue" mb="md">
          Signup functionality will be available soon. Please contact your
          administrator for access.
        </Alert>

        <form onSubmit={form.onSubmit(handleSubmit)}>
          <Group direction="column" grow>
            <TextInput
              label="Name"
              placeholder="Your name"
              value={form.values.name}
              onChange={(event) =>
                form.setFieldValue("name", event.currentTarget.value)
              }
              disabled
            />

            <TextInput
              required
              label="Email"
              placeholder="your@email.com"
              value={form.values.email}
              onChange={(event) =>
                form.setFieldValue("email", event.currentTarget.value)
              }
              error={form.errors.email && "Invalid email"}
              disabled
            />

            <PasswordInput
              required
              label="Password"
              placeholder="Your password"
              value={form.values.password}
              onChange={(event) =>
                form.setFieldValue("password", event.currentTarget.value)
              }
              error={
                form.errors.password &&
                "Password should include at least 6 characters"
              }
              disabled
            />
          </Group>

          <Group position="right" mt="xl">
            <Button type="submit" disabled>
              Register
            </Button>
          </Group>
        </form>
      </Paper>
    </Container>
  );
}
